import React from 'react'

import classNames from 'classnames'

import helper from 'emailThreadViewer/helper'

import styles from './style.module.scss'

interface FTIconProps {
  fileName: string
  size?: number
  className?: string
  colorType?: string
}

interface FTIconState {
  imgSrc: string
  text: string | null
  size: number | null
  alt: string
}

class FTIcon extends React.Component<FTIconProps, FTIconState> {
  state: FTIconState = {
    imgSrc: '',
    text: null,
    size: null,
    alt: '',
  }

  async componentDidMount(): Promise<void> {
    await this.applyProps()
  }

  async componentDidUpdate(prevProps: FTIconProps): Promise<void> {
    const { fileName, size } = this.props

    if (fileName !== prevProps.fileName || size !== prevProps.size) {
      await this.applyProps()
    }
  }

  componentWillUnmount(): void {}

  applyProps = async (): Promise<void> => {
    const { fileName, size } = this.props

    // console.log(fileName, fileType, size)

    const fileIconState = await helper.getFileIcon(fileName)

    this.setState((prevState) => ({
      ...prevState,
      ...fileIconState,
      size: size ?? null,
    }))
  }

  render(): React.ReactElement {
    const { imgSrc, text, size, alt } = this.state
    const { className } = this.props

    const styleProps: React.CSSProperties = {}
    if (size != null) {
      styleProps.width = size
    }

    const textElem = text != null ? <div className={classNames('type')}>{text}</div> : ''

    return (
      <div className={classNames(styles.ftIcon, 'ftIcon', className)}>
        {/* 초기 렌더(getFileIcon 비동기 resolve 전)엔 imgSrc 가 '' 라 빈 문자열 src 경고가 난다.
            undefined 를 넘겨 src 속성 자체를 생략(요소·width 스타일은 유지해 로드 후 reflow 방지).
            data-theme-static: 멀티컬러 파일형식 아이콘 — host 다크모드의 `<img>` SVG 반전(index.css)에서
            제외한다. 목록 AttachmentChip 과 같은 규약. 없으면 회색 unknown 이 다크에서 검정이 된다. */}
        <img data-theme-static src={imgSrc || undefined} style={styleProps} alt={alt} />
        {textElem}
      </div>
    )
  }
}

export default FTIcon
